import { ExclamationCircleIcon } from "@heroicons/react/24/outline"
import * as Sentry from "@sentry/react"
import React from "react"
import { Link, useRouteError } from "react-router"

export function ErrorPage() {
  const error = useRouteError()
  React.useEffect(() => {
    if (error) {
      console.error(error)
      Sentry.captureException(error)
    }
  }, [error])

  return (
    <div className="w-full">
      <div className="container mx-auto flex flex-col pt-20 sm:w-1/2">
        <ExclamationCircleIcon className="mb-2 mr-auto h-16 w-16 text-gray-300" />
        <h1 className="text-2xl font-bold leading-loose text-gray-500">
          Something went wrong
        </h1>
        <p>
          Apologies, this looks like an error on our end. <br />
          Try reloading or go{" "}
          <Link to="/" className="mt-6 font-bold text-indigo-500">
            Home
          </Link>
        </p>
      </div>
    </div>
  )
}
